"use strict";

var _createForOfIteratorHelper = require("/Users/JamesMontes/Documents/MobileApps/majocobos/majocobos/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _classCallCheck = require("/Users/JamesMontes/Documents/MobileApps/majocobos/majocobos/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/JamesMontes/Documents/MobileApps/majocobos/majocobos/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InteractionManager = void 0;

var Grabber_1 = require("../../Interactions/External/Grabber");

var Repulser_1 = require("../../Interactions/External/Repulser");

var Bubbler_1 = require("../../Interactions/External/Bubbler");

var Connector_1 = require("../../Interactions/External/Connector");

var Linker_1 = require("../../Interactions/Particles/Linker");

var Attractor_1 = require("../../Interactions/Particles/Attractor");

var Collider_1 = require("../../Interactions/Particles/Collider");

var Infecter_1 = require("../../Interactions/Particles/Infecter");

var TrailMaker_1 = require("../../Interactions/External/TrailMaker");

var Attractor_2 = require("../../Interactions/External/Attractor");

var Lighter_1 = require("../../Interactions/Particles/Lighter");

var Lighter_2 = require("../../Interactions/External/Lighter");

var Bouncer_1 = require("../../Interactions/External/Bouncer");

var InteractionManager = /*#__PURE__*/function () {
  function InteractionManager(container) {
    _classCallCheck(this, InteractionManager);

    this.container = container;
    this.externalInteractors = [new Bouncer_1.Bouncer(container), new Bubbler_1.Bubbler(container), new Connector_1.Connector(container), new Grabber_1.Grabber(container), new Lighter_2.Lighter(container), new Attractor_2.Attractor(container), new Repulser_1.Repulser(container), new TrailMaker_1.TrailMaker(container)];
    this.particleInteractors = [new Attractor_1.Attractor(container), new Lighter_1.Lighter(container), new Collider_1.Collider(container), new Infecter_1.Infecter(container), new Linker_1.Linker(container)];
  }

  _createClass(InteractionManager, [{
    key: "init",
    value: function init() {}
  }, {
    key: "externalInteract",
    value: function externalInteract(delta) {
      var _iterator = _createForOfIteratorHelper(this.externalInteractors),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var interactor = _step.value;

          if (interactor.isEnabled()) {
            interactor.interact(delta);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, {
    key: "particlesInteract",
    value: function particlesInteract(particle, delta) {
      var _iterator2 = _createForOfIteratorHelper(this.externalInteractors),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var interactor = _step2.value;
          interactor.reset(particle);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      var _iterator3 = _createForOfIteratorHelper(this.particleInteractors),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var _interactor = _step3.value;

          if (_interactor.isEnabled(particle)) {
            _interactor.interact(particle, delta);
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    }
  }]);

  return InteractionManager;
}();

exports.InteractionManager = InteractionManager;